var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "lexon-kanban-filters-container" }, [
    _c("section", { staticClass: "filters-container" }, [
      _c(
        "div",
        { staticClass: "row-1" },
        [
          _c(
            "div",
            { staticClass: "search-input-container" },
            [
              _c("span", { staticClass: "search-text" }, [
                _vm._v(_vm._s(`${_vm.texts.search}:`)),
              ]),
              _c("LexonTextFieldComponent", {
                staticClass: "filter-input",
                attrs: {
                  id: "search",
                  placeholder: _vm.texts.searchPlaceholder,
                },
                on: { input: _vm.emitSearchTerm },
                model: {
                  value: _vm.searchTerm,
                  callback: function ($$v) {
                    _vm.searchTerm = $$v
                  },
                  expression: "searchTerm",
                },
              }),
            ],
            1
          ),
          _c("LfLabelButtonComponent", {
            staticClass: "action-button",
            attrs: {
              text: _vm.texts.cleanFilters,
              action: _vm.clearFilters,
              disabled: _vm.filterButtonStatus,
              variant: _vm.outlinedVariant,
            },
          }),
        ],
        1
      ),
      _c("div", { staticClass: "row-2" }, [
        _c(
          "section",
          { staticClass: "filters-section" },
          [
            _c("LexonAutocompleteComponent", {
              staticClass: "filter-input",
              attrs: {
                "prop-items": _vm.responsibles,
                itemName: "name",
                placeholder: _vm.texts.responsible,
                label: `${_vm.texts.responsible}:`,
                multiple: "",
                chips: "",
              },
              on: {
                change: function ($event) {
                  return _vm.emitFiltersInfo($event, "responsible")
                },
              },
              model: {
                value: _vm.filters.responsible,
                callback: function ($$v) {
                  _vm.$set(_vm.filters, "responsible", $$v)
                },
                expression: "filters.responsible",
              },
            }),
            _c("LexonAutocompleteComponent", {
              staticClass: "filter-input",
              attrs: {
                "prop-items": _vm.actionTypeSidebarFilterOptions,
                itemName: "text",
                placeholder: _vm.texts.type,
                label: `${_vm.texts.type}:`,
                multiple: "",
                chips: "",
              },
              on: {
                change: function ($event) {
                  return _vm.emitFiltersInfo($event, "actionTypeText")
                },
              },
              model: {
                value: _vm.filters.actionTypeText,
                callback: function ($$v) {
                  _vm.$set(_vm.filters, "actionTypeText", $$v)
                },
                expression: "filters.actionTypeText",
              },
            }),
          ],
          1
        ),
      ]),
    ]),
    _c("div", { staticClass: "actions-container" }, [
      _c("p", { staticClass: "warning-text" }, [
        _vm._v(_vm._s(_vm.texts.warning)),
      ]),
      _c(
        "div",
        { staticClass: "buttons-container" },
        [
          _c("div", { staticClass: "filter-actions" }, [
            _c(
              "button",
              {
                class: {
                  "selected-button": _vm.groupByTermProp === "idActionType",
                },
                on: {
                  click: function ($event) {
                    return _vm.emitGroupByTerm("Tipo")
                  },
                },
              },
              [_vm._v(_vm._s(_vm.texts.type))]
            ),
            _c(
              "button",
              {
                class: {
                  "selected-button": _vm.groupByTermProp === "responsible",
                },
                on: {
                  click: function ($event) {
                    return _vm.emitGroupByTerm("Responsable")
                  },
                },
              },
              [_vm._v(_vm._s(_vm.texts.responsible))]
            ),
            _c(
              "button",
              {
                class: {
                  "selected-button": _vm.groupByTermProp === "dateWithoutHour",
                },
                on: {
                  click: function ($event) {
                    return _vm.emitGroupByTerm("Fecha alta")
                  },
                },
              },
              [_vm._v(_vm._s(_vm.texts.startDate))]
            ),
          ]),
          _c("div", { staticClass: "sort-actions" }, [
            _c(
              "button",
              {
                class: {
                  "selected-button": _vm.sortByOptionProp === "Ascending",
                },
                on: {
                  click: function ($event) {
                    return _vm.emitSortByOption("Ascending")
                  },
                },
              },
              [_c("span", { class: _vm.icon.arrowUp })]
            ),
            _c(
              "button",
              {
                class: {
                  "selected-button": _vm.sortByOptionProp === "Descending",
                },
                on: {
                  click: function ($event) {
                    return _vm.emitSortByOption("Descending")
                  },
                },
              },
              [_c("span", { class: _vm.icon.arrowDown })]
            ),
          ]),
          _c(
            "v-menu",
            {
              attrs: {
                bottom: "",
                "nudge-bottom": "38",
                "content-class": "navigation-context-menu",
                "close-on-content-click": false,
              },
              scopedSlots: _vm._u([
                {
                  key: "activator",
                  fn: function ({ on, attrs }) {
                    return [
                      _c(
                        "button",
                        _vm._g(_vm._b({}, "button", attrs, false), on),
                        [
                          _c("LfLabelButtonComponent", {
                            staticClass: "action-button",
                            attrs: {
                              text: _vm.texts.configurationText,
                              variant: _vm.outlinedVariant,
                              prependIcon: _vm.icon.config,
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ]),
            },
            [
              _c(
                "v-list",
                { staticClass: "kanban-checkboxes-list" },
                _vm._l(_vm.parsecheckboxes, function (checkbox, checkboxIndex) {
                  return _c(
                    "v-list-item",
                    { key: checkboxIndex, class: { checked: checkbox.value } },
                    [
                      _c("label", { staticClass: "label" }, [
                        _c("input", {
                          staticClass: "checkbox",
                          attrs: {
                            id: checkbox.keyField,
                            name: checkbox.keyField,
                            type: "checkbox",
                          },
                          domProps: { checked: checkbox.value },
                          on: {
                            input: function ($event) {
                              return _vm.emitToggleColumn(
                                $event,
                                checkbox.keyField,
                                checkboxIndex
                              )
                            },
                          },
                        }),
                        _c("span", [_vm._v(_vm._s(checkbox.headerText))]),
                      ]),
                    ]
                  )
                }),
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }